import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { timeout: { type: Number, default: 45000 } }

  connect() {
    this.pollingTimeout = setTimeout(() => {
      Turbo.visit(window.location.href, { action: 'replace' })
    }, this.timeoutValue)
  }

  disconnect() {
    if (this.pollingTimeout) {
      clearTimeout(this.pollingTimeout)
      this.pollingTimeout = null
    }
  }
}
